import React, { Component, Fragment } from 'react';
import { observer } from 'mobx-react';
import b from 'b_';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { ObservableBulkEditor } from './BulkEditor';
import { ObservableFuseSearchText } from '../FuseSearchText/FuseSearchText';
import { ConsoleCard, ConsoleCardTitle } from '../ConsoleFragments';
import BulkEditorStore from '../../stores/BulkEditorStore';
import Icon from '../Icon/Icon';
import './UrlBulkEditor.css';

const block = b.lock('UrlBulkEditor');

class UrlBulkEditor extends Component {
    static propTypes = {
        store: BulkEditorStore.PropType.isRequired,
        placeholder: PropTypes.string,
        validUrlText: PropTypes.node,
        errorMassage: PropTypes.node,
        warningMessage: PropTypes.node,
        getErrorMessage: PropTypes.func,
        cardWrapperClassName: PropTypes.string,
        cardClassName: PropTypes.string,
        invalidCount: PropTypes.number,
        qa: PropTypes.string,
    };

    goTo = () => {
        this.props.store.bulkEditorStore.goTo(this.getFirstIndexOfInvalidUrl());
    };

    goToWarning = () => {
        this.props.store.bulkEditorStore.goTo(this.props.store.bulkEditorStore.lastDupedPatternIndex + 1);
    };

    getFirstIndexOfInvalidUrl = () => {
        return this.props.store.bulkEditorStore.indexOfFirstInvalidUrl + 1;
    };

    getErrorMessage = () => {
        const { store, errorMassage, getErrorMessage } = this.props;
        const message = !getErrorMessage ? errorMassage :
            getErrorMessage(store.bulkEditorStore.failedValidatorsIndexes || []);
        const afterWarning = store.bulkEditorStore.hasWarnings();
        return <div className={block('ErrorMessage', { afterWarning })}>{message}</div>;
    };

    getWarningMessage = () =>
        <div className={block('WarningMessage')}>
            {this.props.warningMessage || 'Duplicate IP addresses or URL patterns will be deleted on save'}
        </div>;

    render() {
        const { store, placeholder, validUrlText, cardWrapperClassName, cardClassName, invalidCount, qa } = this.props;
        return <div className={cn(block('ConsoleCardWrapper'), cardWrapperClassName)} data-qa={qa}>
            <ConsoleCard className={cn(block('ConsoleCard'), cardClassName)}>
                <div className={block('CardTitle')}>
                    {validUrlText ? <Fragment>
                        <span className={block('ValidRows')}>
                            <b>{`${validUrlText} `}</b>
                        ({(store.bulkEditorStore.urlPatternsSize
                            - (store.bulkEditorStore.invalidUrlPatternsCount || 0)).toLocaleString()})
                        </span>
                    </Fragment> : null}
                    <ObservableFuseSearchText
                        className={block('SearchText')}
                        store={store.fuseSearchTextStore}
                    />
                </div>
                {store.bulkEditorStore.hasWarnings()
                    ? <ConsoleCardTitle className={block('CardTitleWarning')}>
                        <button className={block('WarningButton')} onClick={this.goToWarning}>
                            <Icon className={block('WarningIcon')} type={'warning'} />
                            <span>Duplicates Detected ({
                                store.bulkEditorStore.duplicatePatternsCount.toLocaleString()})</span>
                        </button>
                    </ConsoleCardTitle>
                    : null}
                {store.bulkEditorStore.invalidUrlPatternsCount > 0
                    ? <ConsoleCardTitle className={block('CardTitleError')}>
                        <button className={block('ErrorButton')} onClick={this.goTo}>
                            <Icon className={block('ErrorIcon')} type={'error'} />
                            <span>Validation Errors ({
                                store.bulkEditorStore.invalidUrlPatternsCount.toLocaleString()})</span>
                        </button>
                    </ConsoleCardTitle>
                    : null}
                <ObservableBulkEditor
                    invalidCount={invalidCount}
                    placeholder={placeholder || 'Enter or paste IP addresses and URL patterns'}
                    store={store.bulkEditorStore}
                />
            </ConsoleCard>
            {store.bulkEditorStore.hasWarnings() ? this.getWarningMessage() : null}
            {store.bulkEditorStore.invalidUrlPatternsCount > 0 ? this.getErrorMessage() : null}
        </div>;
    }
}

export default observer(UrlBulkEditor);
